module.exports = __webpack_public_path__ + "img/ic_16_copy.de008709.svg";